module.exports = __webpack_public_path__ + "web_static/img/man.bacac4bc.png";